import React from "react";
import ErrorPage from "../pages/ErrorPage";
import * as Sentry from "@sentry/react";

const ErrorBoundaryContainer: React.FC = (props) => {
    return (
        <Sentry.ErrorBoundary fallback={() => <ErrorPage />}>
            {props.children}
        </Sentry.ErrorBoundary>
    );
};

export default ErrorBoundaryContainer;
